import {
  IonButtons,
  IonContent,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonRouterOutlet,
  IonSplitPane,
  IonToolbar,
} from "@ionic/react";
import { Route, useParams } from "react-router";
import ExploreContainer from "../../components/formComponents/ExploreContainer/ExploreContainer";
import Menu from "../../components/formComponents/Menu/Menu";
import "./Page.css";
import { Typography } from "@mui/joy";

const Page = () => {
  const { name } = useParams<{ name: string }>();

  return (
    <IonSplitPane contentId="main">
      <Menu />
      <IonRouterOutlet id="main">
        <Route path="/portal/:name" exact={true}>
          <IonPage>
            <IonHeader className="header">
              <IonToolbar>
                <IonButtons slot="start">
                  <IonMenuButton />
                  <Typography level="title-md" margin={"10px"}>
                    {name.toUpperCase()}
                  </Typography>
                </IonButtons>
              </IonToolbar>
            </IonHeader>
            <IonContent fullscreen>
              <IonHeader collapse="condense">
                <IonToolbar>
                  <Typography level="title-md">{name.toUpperCase()}</Typography>
                </IonToolbar>
              </IonHeader>
              <ExploreContainer name={name} />
            </IonContent>
          </IonPage>
        </Route>
      </IonRouterOutlet>
    </IonSplitPane>
  );
};

export default Page;
